/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {forwardRef} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useFormikContext} from 'formik';
import {Button} from 'react-bootstrap';

const messages = defineMessages({
  cancel: {id: 'button.cancel'},
});

const CancelButton = (
  {
    message = messages.cancel,
    variant = 'secondary',
    disabled = false,
    ...props
  },
  ref
) => {
  const {isSubmitting} = useFormikContext();

  return (
    <Button
      ref={ref}
      variant={variant}
      disabled={isSubmitting || disabled}
      {...props}
    >
      <FormattedMessage {...message} />
    </Button>
  );
};
CancelButton.displayName = 'CancelButton';

export default forwardRef(CancelButton);
